import { NgFor } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { CarouselComponent } from 'src/app/components/carousel/carousel.component';
import { StoryblokDirective } from 'src/app/directive/storyblok.directive';

@Component({
  selector: 'app-review-callout',
  standalone: true,
  imports: [NgFor, StoryblokDirective, CarouselComponent],
  templateUrl: './review-callout.component.html',
  styleUrl: './review-callout.component.scss',
})
export class ReviewCalloutComponent implements OnInit {
  @Input() slides: any;
  @Input() component!: string;

  @Input() _editable: any;
  @Input() _uid!: string;
  options = {
    0: { slides: 1, nav: true },
  };

  ngOnInit() {
    this.slides = [...this.slides, ...this.slides];
  }
}
